import { BoardsOnboardingStep, Feature } from '../../../constants/Feature';
import { useOnboardingFeature } from '../useFeatureOnboarding';

export const useBoardsOnboarding = () => useOnboardingFeature<BoardsOnboardingStep>(Feature.Boards);
